const TEXT = {
	SERVER_UNAVAILABLE: 'Servidor indisponível',
	EXPIRED_SESSION: 'Sessão expirada, faça login novamente.',
	SERVER_ERROR: 'Erro no servidor',
	LOGIN_TITLE: 'Vamos começar?',
	LOGIN_SUBTITLE: 'Preencha com o seu e-mail',
	LOGIN_EMAIL_INPUT: 'Digite seu E-mail',
	LOGIN_PASSWORD_INPUT: 'Digite sua Senha',
	GO_BACK: 'Voltar',
	LOGIN_GOOGLE_TEXT: 'Continuar com o Google',
	SEND_EMAIL_BUTTON_TEXT: 'Enviar',
	ALREADY_SUBSCRIBER_TEXT: 'Você já é assinante',
	ALREADY_SUBSCRIBER_DESCRIPTION:
		'Para dar continuidade precisamos que você acesse sua conta.',
	SEND_PASSWORD_BUTTON_TEXT: 'Entrar',
	RECOVER_PASSWORD_TEXT: 'Esqueci a senha',
	BUTTON_SUBSCRIPTION_TEXT: 'Assinar',
	BUTTON_SUBSCRIPTION_STICKY_TEXT: 'Assine agora',
	HOME_SLUG: 'Apoie o jornalismo independente.',
	HOME_SUB_SLUG: 'Defendemos a democracia, a transparência nos gastos públicos e os interesses dos cidadãos, estimulando o debate na construção do pensamento crítico sobre os temas mais relevantes para a sociedade. Assine o combo O Antagonista + Crusoé e tenha acesso a um conteúdo de credibilidade, acessível e multiplataforma.',
	CHOOSE_SUBSCRIPTION: 'Escolha sua assinatura:',
	MENSAL_SUBSCRIPTION: 'Plano Mensal',
	ANUAL_SUBSCRIPTION: 'Plano Anual',
	SUBSCRIPTION_FROM: 'Planos a partir de',
	SUBSCRIPTION_FROM_CUPOM: 'Opções de Planos',
	ALREADY_HAVE_ACCOUNT: 'JÁ POSSUI UMA CONTA?',
	DO_LOGIN: 'FAÇA O LOGIN',
	REGISTER_TITLE: 'agora vamos criar sua conta',
	REGISTER_PARAGRAPH1:
		'Para continuar com a solicitação, iremos criar sua conta de acesso.',
	REGISTER_PARAGRAPH2:
		'	Preencha as informações abaixo para criarmos sua Conta de Acesso ao Portal:',
	BIRTH_DATE: 'Data de Nascimento',
	CHOOSE_PAYMENT: 'ESCOLHA COMO PAGAR',
	CUPOM_CODE: 'Insira o código do cupom',
	TERMS: 'Li e concordo com os Termos de Uso e Política de Privacidade.',
	SUBSCRIPTION_NOTIFICATION:
		'Aceito receber notificações sobre minha assinatura.',
	CHANGE_PLAN: 'Trocar Plano',
	REGISTER_PARAGRAPH_EXIST_USER:
		'Para continuarmos com a solicitação, confira as informações que já foram cadastradas previamente e corrija algum dado se necessário.',
	PAYMENT_TITLE: 'Realize o pagamento para concluir sua assinatura',
	DOWNLOAD_MESSAGE:
		'Faça o download do aplicativo através da Apple Store ou Google Play',
	SEE_BOLETO: 'Visualizar Boleto',
	COPY_TEXT: 'Ou copie este código abaixo para realizar o pagamento:',
	LOADING_MESSAGE: 'Verificando status do pagamento',
	SUBSCRIPTION_SUCCESS: 'Assinatura efetuada com sucesso',
	SUBSCRIPTION_FAILURE: 'Não foi possível realizar sua assinatura',
	SUBSCRIPTION_ERROR_MESSAGE:
		'Infelizmente não conseguimos processar seu pagamento através de seu <strong>Cartão de Crédito</strong>. Sugerimos que você revise os dados informados e se caso estejam corretos, avalie se há saldo disponível para a conclusão da sua compra. Caso o erro persista, você pode optar por alterar o <strong>Método de Pagamento</strong>.',
	ACCESS_MY_ACCOUNT: 'Acessar minha conta',
	CORRECT_DATA: 'CORRIGIR DADOS',
	USER_EXIST_TITLE: 'O e-mail digitado já possui uma assinatura ativa.'
}

const ERROR_MESSAGES = {
	AUTHENTICATION_FAILED: 'Falha na autenticação',
	RECOVER_PASSWORD_FAILED: 'Falha ao recuperar senha',
	GOOGLE_LOGIN_ERROR: 'Não foi possível realizar o login, tente novamente'
}

const SUCCESS_MESSAGES = {
	RECOVER_PASSWORD_SUCCESS: 'E-mail enviado!'
}

export { TEXT, ERROR_MESSAGES, SUCCESS_MESSAGES }
